{
  "moreActions": "المزيد من الإجراءات",
  "unavailable": "غير مُتوفر، قُم بالتوسيع للحصول على التفاصيل",
  "backButton": "Return to {prevMenuButton}"
}
